import React, { useState } from 'react';

const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = useState(false);

  const fallbackUI = (
    <div>
      <h1>Something went wrong.</h1>
      <p>Please try again later.</p>
    </div>
  );

  try {
    if (hasError) {
      throw new Error('Error Boundary Triggered');
    }
    return children;
  } catch (error) {
    setHasError(true);
    console.error('ErrorBoundary caught an error:', error);
    return fallbackUI;
  }
};

export default ErrorBoundary;
